import { render, staticRenderFns } from "./AddItemToCategory.vue?vue&type=template&id=4eaeda7e"
import script from "./AddItemToCategory.vue?vue&type=script&lang=js"
export * from "./AddItemToCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports